import React from 'react';
export var defaultTranslations = {
    pluginName: 'Spacer',
    pluginDescription: 'Resizeable, horizontal and vertical empty space.',
    elementHeightLabel: 'Element height (px)',
};
export var defaultSettings = {
    Renderer: function () { return React.createElement(React.Fragment, null, "Renderer; for this plugin was not provided "); },
    translations: defaultTranslations,
};
//# sourceMappingURL=settings.js.map